export const DEFAULT_SETTINGS = {
  account: {
    brands: {
      position: 'DEFAULT' as 'DEFAULT' | 'LEFT' | 'CENTER' | 'RIGHT',
      fillingType: '', // 'FIT' | 'FULL'
      template: 'SaaS' as 'SaaS' | 'doc' | 'meeting',
      backgroundType: '', // 'IMAGE' | 'COLOR',
      customCssEnabled: false,
      css: '',
      imageUrl: '',
      color: '',
      id: '', // 有值则为修改后的数据，无值则为默认数据
    },
    companyInfo: {
      logoUrl: '',
      companyName: '',
    },
    apps: [] as {
      name: string;
      vendorType: string;
      appType: string;
    }[],
  },
  system: {
    smsEnabled: true,
  },
};
